import { render, staticRenderFns } from "./KnInventoryMovementReasons.vue?vue&type=template&id=5715b35e&"
import script from "./KnInventoryMovementReasons.vue?vue&type=script&lang=js&"
export * from "./KnInventoryMovementReasons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports